import { createAction } from "@reduxjs/toolkit";
import { Camera } from "src/types/camera";

export const CAMERA_GET_ALL = createAction<{ cameras: Camera[] }>("@camera/GET_ALL");
export const CAMERA_ADD = createAction<{ camera: Camera }>("@camera/ADD");
export const CAMERA_DELETE = createAction<{ cameraId: string }>("@camera/DELETE");
